import React, {useState} from "react";
import {Box, Button, Drawer, IconButton, Stack} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import {Link as RouterLink} from "react-router";
import PATH from "../../routing/routes";

const MobileMenu = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <Box display="flex" justifyContent="flex-end" alignItems="center">
            <IconButton
                onClick={() => setMobileMenuOpen(true)}
                sx={{
                    color: 'primary.contrastText',
                    backgroundColor: 'primary.main',
                    '&:hover': {
                        backgroundColor: 'primary.light',
                    },
                    marginRight: "8px",
                    marginBottom: "8px"
                }}
            >
                <MenuIcon/>
            </IconButton>

            <Drawer
                anchor="right"
                open={mobileMenuOpen}
                onClose={() => setMobileMenuOpen(false)}
            >
                <Box sx={{p: 2}}>
                    <IconButton
                        onClick={() => setMobileMenuOpen(false)}
                    >
                        <CloseIcon/>
                    </IconButton>
                    <Box sx={{height: '20px'}}/>
                    <Stack spacing={2}>
                        <Button to={PATH.HOME} component={RouterLink}
                                onClick={() => setMobileMenuOpen(false)}
                                sx={{width: '100%'}}>
                            Despre noi
                        </Button>

                        <Button to={PATH.CAMPS_CLASSICS} component={RouterLink}
                                onClick={() => setMobileMenuOpen(false)}
                                sx={{width: '100%'}}>
                            Tabere de limbi clasice
                        </Button>

                        <Button to={PATH.CAMPS_ENGLISH} component={RouterLink}
                                onClick={() => setMobileMenuOpen(false)}
                                sx={{width: '100%'}}>
                            Tabere de limba engleză
                        </Button>

                        <Button to={PATH.CONTACT} component={RouterLink}
                                onClick={() => setMobileMenuOpen(false)}
                                sx={{width: '100%'}}>
                            Contact
                        </Button>
                    </Stack>
                </Box>
            </Drawer>
        </Box>
    );
};
export default MobileMenu